export default {
  list: { lazy: () => import('./Utilities'), component: 'UtilityList' },
  edit: { lazy: () => import('./Utilities'), component: 'UtilityEdit' },
  create: { lazy: () => import('./Utilities'), component: 'UtilityCreate' },
}
